module.exports = __webpack_public_path__ + "img/fix.4399c019.jpg";